import logo from "./images/highResLogo.png";
import "./App.css";

import InitAuth from "./initialAuth";
import { Button } from "@mui/material";
import { useEffect } from "react";

export interface HomeProps {
  auth?: boolean;
}

function Home({ auth = false }: HomeProps) {
  //InitAuth();
  useEffect(() => {
    window.scrollTo({ top: auth ? 0 : 100 });
  }, [auth]);

  return (
    <div className="App">
      <header className="App-header">
        <img className="logo" src={logo} alt="ACC Logo" />
        <br />
        <div
          style={{
            border: "2px solid red",
            padding: "0px 50px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <h3> Are you looking for my resume? </h3>
            <h6>
              If you are interested in my resume, that can be downloaded without
              logging in!
            </h6>
          </div>
          <div style={{ verticalAlign: "middle", justifyContent: "center" }}>
            <Button
              variant="contained"
              size="large"
              sx={{ bgcolor: "#ffffff", color: "#000", minWidth: 120 }}
              onClick={() => {
                window.location.href = "/resume";
              }}
            >
              Resume
            </Button>
          </div>
        </div>

        <InitAuth />
      </header>
    </div>
  );
}

export default Home;
